module.exports = __webpack_public_path__ + "static/media/us-map-planning.deca1be1.svg";